var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMobileTf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8266 1.33333H5.17329C3.33329 1.33333 2.66663 1.99999 2.66663 3.87333V12.1267C2.66663 14 3.33329 14.6667 5.17329 14.6667H10.82C12.6666 14.6667 13.3333 14 13.3333 12.1267V3.87333C13.3333 1.99999 12.6666 1.33333 10.8266 1.33333ZM7.99996 12.8667C7.35996 12.8667 6.83329 12.34 6.83329 11.7C6.83329 11.06 7.35996 10.5333 7.99996 10.5333C8.63996 10.5333 9.16663 11.06 9.16663 11.7C9.16663 12.34 8.63996 12.8667 7.99996 12.8667ZM9.33329 4.16666H6.66663C6.39329 4.16666 6.16663 3.94 6.16663 3.66666C6.16663 3.39333 6.39329 3.16666 6.66663 3.16666H9.33329C9.60663 3.16666 9.83329 3.39333 9.83329 3.66666C9.83329 3.94 9.60663 4.16666 9.33329 4.16666Z",
    fill: "#808985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileTf);
export default __webpack_public_path__ + "static/media/icon_mobileTF.18e2132e0488cdfb4166521249996603.svg";
export { ForwardRef as ReactComponent };